import { jwtDecode } from 'jwt-decode';
import { authCookies } from './cookies';

export const decodeAndValidateToken = (token) => {
    try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return {
            decoded: decodedToken,
            isExpired: !decodedToken.exp || decodedToken.exp < currentTime,
            expiresIn: decodedToken.exp ? decodedToken.exp - currentTime : 0
        };
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

export const checkExistingTokens = () => {
    const idToken = authCookies.getIdToken();
    if (!idToken) {
        console.log('No ID token available');
        return null;
    }
    const refreshToken = authCookies.getRefreshToken();
    if (!refreshToken) {
        console.log('No refresh token available');
    }
    const tokenValidation = decodeAndValidateToken(idToken);
    if (tokenValidation && tokenValidation.isExpired) {
        console.log('ID token expired');
        if (!refreshToken) {
            throw new Error('No refresh token available');
        }
        console.log('Token refresh needed');
    }
    return {
        accessToken: authCookies.getAccessToken(),
        idToken: idToken,
        tokenValidation
    };
};

export const getUserInfoFromToken = (token) => {
    const validation = decodeAndValidateToken(token);
    if (!validation) return null;
    const { decoded } = validation;
    return {
        sub: decoded.sub,
        email: decoded.email,
        name: decoded.name,
        given_name: decoded.given_name,
        family_name: decoded.family_name,
        email_verified: decoded.email_verified,
        aud: decoded.aud,
        iss: decoded.iss,
        exp: decoded.exp,
        iat: decoded.iat
    };
}; 